module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"a":"Choisissez votre équipe","c":"Vous souhaitez créer une autre équipe ?","d":"Contactez-nous à"},"en":{"a":"Choose your team","b":"Choose","c":"You want to create a new team ?","d":"Contact us at"}}')
  delete Component.options._Ctor
}
